export default class Glossary {
	constructor() {
		const phraseClass: string = '.glossaryPhrase';
		const phraseList: NodeListOf<Element> = document.querySelectorAll(phraseClass);
		
		function addTooltipContent(definitions: any) {
			for(let i = 0; i < phraseList.length; i++) {
				let phrase: Element = phraseList[i];
				let entryKey: string = phrase.getAttribute('rel');

				// set attribute on span element after phrase link
				(phrase.nextSibling as HTMLElement).setAttribute('data-glossary', definitions[entryKey]);
			}
		}

		window.onload = () => {
			const definitions = (window as any).glossaryDefinitions;
			addTooltipContent(definitions);
		}
	}
}